// initial state
const initialState = () => ({
  accordionItems: {},
  additiveAccordionItems: {},
});

function ensureObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function ensurePointState(items, pointID) {
  if (!pointID) return null;

  if (!items[pointID] || typeof items[pointID] !== 'object' || Array.isArray(items[pointID])) {
    items[pointID] = {};
  }

  return items[pointID];
}

// getters
const getters = {
  stateAllCategories(state) {
    return state.accordionItems;
  },
  stateAllAdditives(state) {
    return state.additiveAccordionItems;
  },
  getCatById: (state) => (id) => {
    return state.accordionItems[id];
  },
};

// actions
const actions = {
  getCategoryById({ getters }, id) {
    const item = getters.getCatById(id);
    console.log(item);
  },
};

// mutations
const mutations = {
  ACCORDION_RESET_STATE(state) {
    Object.assign(state, initialState());
  },
  setCategoriesState(state, points) {
    state.accordionItems = ensureObject(state.accordionItems);

    points.forEach((point) => {
      const statePoint = ensurePointState(state.accordionItems, point?.id);
      if (!statePoint) return;

      const pointCategories = Array.isArray(point?.categories) ? point.categories : [];
      const isStateCategories = Object.keys(statePoint).length;

      const isPointCategories = pointCategories.length;

      const hasActualCategoryKeys = pointCategories.every((category) => (
        Object.prototype.hasOwnProperty.call(statePoint, category.id)
      ));
      const compareCategories = isStateCategories !== isPointCategories || !hasActualCategoryKeys;
      if (compareCategories) {
        state.accordionItems[point.id] = isPointCategories
          ? pointCategories.reduce((a, c) => {
              return {
                ...a,
                [c.id]: statePoint[c.id] ?? false,
              };
            }, {})
          : {};
      } else {
        //         console.log("exist!");
      }
    });
  },
  setCategoriesStateDirectly(state, accordionState) {
    state.accordionItems = ensureObject(accordionState);
  },
  setAdditivesState(state, points) {
    points.forEach((point) => {
      if (state.additiveAccordionItems[point.id]) {
        return;
      }
      const statePoint = state.additiveAccordionItems[point.id];

      const isStateGroups = state.additiveAccordionItems[point.id]
        ? Object.keys(state.additiveAccordionItems[point.id]).length
        : 0;

      const isPointGroups = point?.groups ? point.groups.length : 0;

      const compareGroups = isStateGroups !== isPointGroups;
      if (!statePoint || compareGroups) {
        state.additiveAccordionItems[point.id] = isPointGroups
          ? point.groups?.reduce((a, c) => {
              return {
                ...a,
                [c.id]: false,
              };
            }, {})
          : {};
      } else {
        //         console.log("exist!");
      }
    });
  },
  setAdditivesStateDirectly(state, accordionState) {
    state.additiveAccordionItems = accordionState;
  },
  toggleCategoryState(state, payload) {
    state.accordionItems = ensureObject(state.accordionItems);
    const pointState = ensurePointState(state.accordionItems, payload.pointID);
    if (pointState) pointState[payload.id] = !pointState[payload.id];

    sessionStorage.setItem('stateItems', JSON.stringify(state.accordionItems));
  },
  toggleAdditiveState(state, payload) {
    if (state.additiveAccordionItems[payload.pointID]) {
      state.additiveAccordionItems[payload.pointID][payload.id] =
        !state.additiveAccordionItems[payload.pointID][payload.id];
    }
    sessionStorage.setItem('stateAdditiveItems', JSON.stringify(state.additiveAccordionItems));
  },
  setCategoryState(state, payload) {
    state.accordionItems = ensureObject(state.accordionItems);
    const pointState = ensurePointState(state.accordionItems, payload.pointID);
    if (pointState) {
      pointState[payload.id] = payload.st;
      sessionStorage.setItem('stateItems', JSON.stringify(state.accordionItems));
    }
  },
  setAdditiveState(state, payload) {
    if (state.additiveAccordionItems[payload.pointID]) {
      state.additiveAccordionItems[payload.pointID][payload.id] = payload.st;
      sessionStorage.setItem('stateAdditiveItems', JSON.stringify(state.additiveAccordionItems));
    }
  },
  saveToSessionStorage(state) {
    sessionStorage.setItem('stateItems', JSON.stringify(state.accordionItems));
  },
  saveAdditivesToSessionStorage(state) {
    sessionStorage.setItem('stateAdditiveItems', JSON.stringify(state.additiveAccordionItems));
  },
};

export default {
  namespaced: false,
  state: initialState,
  getters,
  actions,
  mutations,
};
